import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";

export default function DetailTearTrough({data, img}) {
    return (
        <MeasurementResult type="눈물고랑" description='눈물고랑은 눈 아래에서 뺨까지 이어지는 선명한 홈으로, 주로 피부 탄력 감소와 지방 감소로 인해 나이가 들면서 더욱 두드러지며, 이는 눈 밑을 꺼져 보이게 하며 다크서클을 강조하고 피로한 인상을 줍니다.' 
        score={data.score}>
            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        {
                        img.image_cross_polar_front &&
                        <img src={img.image_cross_polar_front} />
                        }
                        {
                        img.image_mark_lacrimal_groove_front &&
                        <img src={img.image_mark_lacrimal_groove_front} />
                        }

                        <div className="caption">2D</div>
                    </div>
                    {/* <div className="img-cont detail">
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                    </div> */}
                </div>
                <DegreeSection 
                    type="눈물고랑"
                    badge={data.analysisBadge}
                    items={[
                    {
                        value: "없음",
                        label: "0"
                    },
                    {
                        value: "경도",
                        label: "1"
                    },
                    {
                        value: "경도",
                        label: "2"
                    },
                    {
                        value: "중간 정도",
                        label: "3"
                    },
                    {
                        value: "중간 정도",
                        label: "4"
                    },
                    {
                        value: "중증 정도",
                        label: "5"
                    },
                    {
                        value: "중증 정도",
                        label: "6"
                    },
                ]}
                levelFloat={data.levelFloat}
                text={data.degreeText}
                line={2}
                />
            </div>

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult 
                    text={data.aiResult}
                />
            </div>
        </MeasurementResult>
    )
}